export default () => import(/* webpackChunkName: 'coffee/activities/coupon-gift' */ './CouponGift');
